import uniqid from 'uniqid';

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            localId: null,
            uniqueId: uniqid(),
        };
    },

    beforeMount() {
        this.localId = `${ this._uid }`;
    },

    methods: {
        getId(prefix = '') {
            const id = this.id || this.localId || null;

            if (!id) {
                return null;
            }

            let cleanedPrefix = prefix;

            if (cleanedPrefix) {
                cleanedPrefix = String(cleanedPrefix).replace(/\s+/g, '_');
            }

            return cleanedPrefix
                ? `${ cleanedPrefix }-${ this.uniqueId }-${ id }`
                : `${ id }-${ this.uniqueId }`;
        },
    },
};
